import { addDataLayerEntry, addEventEntry, Events } from '@printdeal/data-layer-manager';
import { AlgoliaABTestIdsProp } from '../../../../algolia-search/types';

interface EventActionProp {
  search_term: string,
  number_of_results: number,
  ab_test_id?: number,
  ab_test_variant_id?: number,
}

const MoreResultsEvent = {
  eventCategory: 'site_search_algolia',
  eventCategorySticky: 'site_search_algolia_sticky',
  eventAction: 'more_results',
  eventLabel: 'top_text_link',
  eventActionSticky: 'more_results_sticky',
};

export const dispatchDataLayerEventOnSearchQueryGA4 = (
  eventName: string,
  search_term: string,
  number_of_results: number,
  algoliaABTestIds?: AlgoliaABTestIdsProp,
) => {
  const eventAction: EventActionProp = {
    search_term,
    number_of_results,
  };
  if (algoliaABTestIds?.abTestID) {
    eventAction.ab_test_id = algoliaABTestIds?.abTestID;
  }
  if (algoliaABTestIds?.abTestVariantID) {
    eventAction.ab_test_variant_id = algoliaABTestIds?.abTestVariantID;
  }

  addDataLayerEntry(
    eventName,
    eventAction,
  );
};

export const dispatchDataLayerEventOnSearchResultsClickGA4 = (
  clicked_result_name: string,
  position: number,
  click_search_location: string,
  type: string,
) => {
  addDataLayerEntry(
    'search_result_click',
    {
      clicked_result_name,
      position,
      click_search_location,
      type,
    },
  );
};

export const dispatchDataLayerEventOnShowAllSearchResultsClickGA = () => {
  // GA3
  addEventEntry({
    eventCategory: MoreResultsEvent.eventCategory,
    eventAction: MoreResultsEvent.eventAction,
    eventLabel: MoreResultsEvent.eventLabel,
  });

  // GA4
  addDataLayerEntry(Events.Event, {
    eventCategory: MoreResultsEvent.eventCategory,
    eventAction: MoreResultsEvent.eventAction,
    eventLabel: MoreResultsEvent.eventLabel,
  });
};
